<template>
  <div class="tabs-wrap">
    <ul class="tabs">
      <li
        v-for="(item, i) in Object.keys(tabs)"
        :key="i"
        :class="{active:activeName === item}"
        @click="handleClick(item)"
      >{{tabs[item]}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'product',
      tabs: {
        product: '产品介绍',
        video: '视频教学'
      }
    }
  },
  methods: {
    handleClick(item) {
      this.activeName = item
      this.$emit('clickTab', item)
    }
  }
}
</script>
<style lang="less" scoped>
.tabs {
  display: flex;
  justify-content: space-between;
  height: 58px;
  border-bottom: 1px solid #e6e8ee;
  margin: 0 auto;
  max-width: 524px;
  li {
    color: #a4a8ab;
    font-size: 20px;
    font-weight: 600;
    padding-top: 20px;
    padding-bottom: 5px;
    cursor: pointer;
    &.active {
      color: #2c5ac8;
      border-bottom: 3px solid #2c5ac8;
    }
  }
}
@media screen and (max-width: 990px) {
  .tabs {
    display: flex;
    justify-content: space-around;
  }
}
</style>

